module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/customer/bethistory/component/form.html
// module id = 1477
// module chunks = 0